import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltVideoEditorPlayerTimelinePlayheadLineWireframe from './VeltVideoEditorPlayerTimelinePlayheadLineWireframe/VeltVideoEditorPlayerTimelinePlayheadLineWireframe';
import VeltVideoEditorPlayerTimelinePlayheadActionsWireframe from './VeltVideoEditorPlayerTimelinePlayheadActionsWireframe/VeltVideoEditorPlayerTimelinePlayheadActionsWireframe';
var VeltVideoEditorPlayerTimelinePlayhead = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-timeline-playhead-wireframe", __assign({}, transformedProps), children));
};
VeltVideoEditorPlayerTimelinePlayhead.Line = VeltVideoEditorPlayerTimelinePlayheadLineWireframe;
VeltVideoEditorPlayerTimelinePlayhead.Actions = VeltVideoEditorPlayerTimelinePlayheadActionsWireframe;
export default VeltVideoEditorPlayerTimelinePlayhead;
